import DatePicker from "react-datepicker";
import { ChangeEvent, useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import InputMask from "react-input-mask";
import { validateDate } from "../utils/GeneralUtils";
import { toast } from "react-toastify";

const FutureDatePicker = (props: any) => {
  const {
    input,
    meta: { touched, error },
    valuedata,
    isValidation,
  } = props;
  // console.log(touched, error);
  // console.log(props);
  const [dateValue, setdateValue] = useState<any>("");

  const handleChangeRaw = (value: any) => {
    if (validateDate(value)) {
      const todayDate = new Date();
      const date = moment(value);
      //setting date to yesterday date for validation of is After
      todayDate.setDate(todayDate.getDate() - 1);
      //condition for checking invalid date entered for feb month
      if (
        moment(value).isAfter(todayDate) &&
        value.slice(0, 2) === date.format("MM")
      ) {
        props.input.onChange(date);
      } else {
        toast.error("Enter future valid date");
      }
    } else {
      props.input.onChange(null);
      if (
        value !== undefined &&
        value !== "" &&
        !value.includes("_") &&
        dateValue !== value
      ) {
        toast.error("Enter valid date(MM/DD/YYYY)");
      }
    }
    setdateValue(value);
  };

  return (
    <>
      <DatePicker
        onSelect={(date: any) => {
          input.onChange(date);
        }}
        dateFormat="MM/dd/yyyy"
        selected={input?.value ? new Date(input?.value) : undefined}
        disabledKeyboardNavigation
        {...props}
        shouldCloseOnSelect={true}
        startDate={input.startDate}
        onChangeRaw={(event) => handleChangeRaw(event.target.value)}
        customInput={<InputMask mask="99/99/9999" />}
        onBlur={(event: any) => {
          input.onBlur(event);
        }}
      />
      <h6 className="future-danger">
        {touched && error ? <h6 className={`${error === "Date is over 12 months" ? "higher" : "danger"}`}>{error}</h6> : ""}
      </h6>
    </>
  );
};

export default FutureDatePicker;
